import DefaultProposalPriceAfterAdjustmentCalculator from "./DefaultProposalPriceAfterAdjustmentCalculator";

export default class DefaultProposalPriceAfterAdjustmentCalculatorFactory {
    private static readonly INSTANCE = new DefaultProposalPriceAfterAdjustmentCalculator();
    public static getInstance() {
        return this.INSTANCE;
    }
}
